module.exports = __webpack_public_path__ + "img/shadow.aa2c2e13.png";